'use strict';

export var modelViewService = function (configService, httpService) {

    var getModelViewLaunchSettings = function (studyId, assetId, entryParameters) {

        return httpService.sendToApi({
                method: 'GET',
                params: entryParameters
            },
            `modelview/launchsettings/${studyId}/${assetId}`
        ).then(res => {
            return res;
        });
    }

    var addTicketParameters = function (ticketId, addedParameters) {

        return httpService.sendToApi({
                method: 'POST',
                params: addedParameters,
                headers: {
                    'TicketId': ticketId
                }
            },
            `ticket/${ticketId}/addparameters`
        ).then(res => {
            return res;
        });
    }

    return {
        getModelViewLaunchSettings: getModelViewLaunchSettings,
        addTicketParameters: addTicketParameters
    };
};

modelViewService.$inject = ['configService', 'httpService'];